import DetailComponent from "../components/DetailComponent";
import useDetail from "../hook/useDetail";

const DetailPage = ({

}) => {
    const detail = useDetail();
    return <DetailComponent {...detail} />
}
export default DetailPage;